/**
 * The PrintRun wordmark that follows the theme: the two-tone logo on a light
 * surface, the white logo once `.dark` is on. Same surface rule as
 * DEFAULT_BRANDING (loadingLogoUrl for white surfaces, logoUrl for dark ones),
 * so a logo swap in branding.ts reaches every caller.
 *
 * Product chrome only (it is always PrintRun, never the org's own logo): for
 * an org-branded spot use resolveBranding() as AppSidebar and LoadingShell do.
 * `className` sizes it (give a height, e.g. `h-5`); do not pass a display
 * class, the light/dark swap owns `display`.
 */
import { DEFAULT_BRANDING } from '@/lib/branding';
import { cn } from '@/lib/utils';

interface PrintRunLogoProps {
  /** Translated alt text. Only the visible image is announced. */
  alt: string;
  className?: string;
}

export function PrintRunLogo({ alt, className }: PrintRunLogoProps) {
  return (
    <>
      <img
        src={DEFAULT_BRANDING.loadingLogoUrl}
        alt={alt}
        width={840}
        height={182}
        decoding="async"
        data-theme-logo="light"
        className={cn('w-auto shrink-0 select-none dark:hidden', className)}
      />
      <img
        src={DEFAULT_BRANDING.logoUrl}
        alt={alt}
        width={1144}
        height={246}
        decoding="async"
        data-theme-logo="dark"
        className={cn('hidden w-auto shrink-0 select-none dark:block', className)}
      />
    </>
  );
}
